import { motion } from "framer-motion";
import { useMemo } from "react";
import CountUp from "react-countup";
import type { Task } from "../../types";
import { estimatedMinutes, taskTagClass, taskTopic } from "../../utils";
import { formatGbp } from "../../utils/currency";
import { cardContentVariants, detailReveal } from "./motion";

const rewardFormatter = (task: Task) => (v: number) => {
  if (task.gbpEquiv != null) {
    return formatGbp(v);
  }

  return `${v} pts`;
};

export function SingleTaskCard({ task }: { task: Task }) {
  const value = useMemo(() => task.gbpEquiv || task.points, [task]);
  // console.log({ task, value });
  return (
    <motion.article className="task-reveal-card" variants={cardContentVariants}>
      <motion.div className="task-reveal-card__top" variants={detailReveal}>
        <div>
          <motion.div
            className="task-reveal-card__eyebrow"
            variants={detailReveal}
          >
            Your next task
          </motion.div>
          <motion.h1
            className="task-reveal-card__title title-lg"
            variants={detailReveal}
          >
            {task.title}
          </motion.h1>
          <motion.p
            className="task-reveal-card__subtitle"
            variants={detailReveal}
          >
            {task.description || "Ready when you are!"}
          </motion.p>
        </div>
        <motion.div
          className="task-reveal-card__reward-wrap"
          variants={detailReveal}
        >
          <div className="task-reveal-card__reward-label">Reward</div>
          <div className="task-reveal-card__reward">
            {!!task && (
              <CountUp
                // decimals={2}
                suffix="pts"
                end={task.points}
                preserveValue
                useEasing
              />
            )}
          </div>
          <div className="task-reveal-card__points">≈ {formatGbp(value)}</div>
        </motion.div>
      </motion.div>

      <motion.div className="task-reveal-card__tags" variants={detailReveal}>
        <span className="tag tag-amber">~{estimatedMinutes(task)} minutes</span>
        {task.tags?.map((tag) => (
          <span className={`tag ${taskTagClass(tag)}`} key={tag}>
            {tag}
          </span>
        ))}
        {taskTopic(task) && (
          <span className={`tag ${taskTagClass(taskTopic(task))}`}>
            {taskTopic(task)}
          </span>
        )}
      </motion.div>

      {task.description ? (
        <motion.p
          className="task-reveal-card__description"
          variants={detailReveal}
        >
          {task.description}
        </motion.p>
      ) : null}
    </motion.article>
  );
}
